import './components/dynamicform'
import './components/ImageGallery'
import Carousel from './components/Carousel'
import { Interval } from './lib/animation'
import { scrollToElement } from './lib/helpers'

const isMobile = () => innerWidth < 768 || /(ipad|ipod|iphone|ios|android)/gi.test(navigator.userAgent)

addEventListener('DOMContentLoaded', () => {
	Carousel.initializeAll()
	initializeMenu()
	initializeScrollToLinks()
	initSubmissionForms()
})

addEventListener('load', () => {
	scrollToContent()
})

function initializeMenu() {
	const nav = document.querySelector('header nav')
	const menu = nav.querySelector('#menu-content')
	const parentItems = [...menu.querySelectorAll('li.has-children')]

	//
	// For mobile devices.
	nav.querySelector('#hamburger')?.addEventListener('click', () => {
		nav.classList.toggle('open')
	})

	// Expanding/collapsing for mobile menu.
	for (const parentItem of parentItems) {
		parentItem.querySelector('div.expander')?.addEventListener('click', function (event) {
			event.preventDefault()
			event.stopPropagation()
			this.parentNode.parentNode.classList.toggle('expanded')
		})
	}
}

// Anchors that link to an element should start a smooth scroll animation.
function initializeScrollToLinks() {
	const anchors = [...document.body.querySelectorAll('a[href*="#"]')]

	for (const anchor of anchors) {
		anchor.addEventListener('click', function (event) {
			let [name] = this.getAttribute('href').match(/\#(.*)$/)
			name = name.replace('#', '')

			if (!name) {
				return
			}

			const targetElement = document.body.querySelector(`*[name=${name}], *[id=${name}]`)
			if (targetElement) {
				event.preventDefault()
				scrollToElement(targetElement)
			}
		})
	}
}

// Scroll to the first content.
function scrollToContent() {
	if (document.body.classList.contains('home')) {
		return
	}

	const firstSection = document.querySelector('#hero + *')
	const nav = document.querySelector('header nav')
	if (firstSection) {
		scrollToElement(firstSection, {
			offsetTop: -(nav?.offsetHeight) || -80
		})
	}
}

// 'Meld je aan' forms.
function initSubmissionForms() {
	const titles = document.querySelectorAll('#meld-je-aan h2')
	for (let a = 0; a < titles.length; a++) {
		titles[a].addEventListener('click', function () {
			this.parentNode.classList.add('active')

			for (let b = 0; b < titles.length; b++) {
				if (this !== titles[b]) {
					titles[b].parentNode.classList.remove('active')
				}
			}
		})
	}
}